import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  toString3o7ifthqydp6e as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Composer1pt8hwk95abxi as Composer,
  ComposerForUnquotedLiterals3v0rwxdudtla9 as ComposerForUnquotedLiterals,
  ComposerForUnsignedNumbers2h1dv6l9z3aef as ComposerForUnsignedNumbers,
} from './Composers.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance14ex35co4jkrb as CLASS_getInstance,
  OBJECT_getInstance26229tfe4t547 as OBJECT_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClassDiscriminatorMode_NONE_getInstance1g0i4x2dh4wbf as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  access$validateIfSealed$tPolymorphicKt4rflg4qeqfyp as access$validateIfSealed$tPolymorphicKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './Polymorphic.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { switchMode35g725ikhjpwv as switchMode } from './WriteMode.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import { InvalidFloatingPointEncoded3n0aum4e9o5qi as InvalidFloatingPointEncoded } from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_jsonUnquotedLiteralDescriptors6ipxyp7dsvf as get_jsonUnquotedLiteralDescriptor } from '../JsonElement.mjs';
import { Companion_getInstanceuedpedmz4g65 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  serializer3ikrxnm8b29d6 as serializer,
  serializer2lw83vwvpnyms as serializer_0,
  serializer36584sjyg5661 as serializer_1,
  serializer1q7c5q67ysppr as serializer_2,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Companion_getInstance1puqqwzccfvrg as Companion_getInstance_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { Companion_getInstance1trnkq9cty7vr as Companion_getInstance_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { Companion_getInstance2du03jiluw9jj as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function encodeTypeInfo($this, discriminator, serialName) {
  $this.a2e_1.r2b();
  $this.p14(discriminator);
  $this.a2e_1.u2b(_Char___init__impl__6a9atx(58));
  $this.a2e_1.t2b();
  $this.p14(serialName);
}
var StreamingJsonEncoderClass;
function StreamingJsonEncoder() {
  if (StreamingJsonEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static t2f(composer, json, mode, modeReuseCache) {
        var $this = this.d14();
        $this.a2e_1 = composer;
        $this.b2e_1 = json;
        $this.c2e_1 = mode;
        $this.d2e_1 = modeReuseCache;
        $this.e2e_1 = $this.b2e_1.mz();
        $this.f2e_1 = $this.b2e_1.s27_1;
        $this.g2e_1 = false;
        $this.h2e_1 = null;
        $this.i2e_1 = null;
        var i = $this.c2e_1.b4_1;
        if (!($this.d2e_1 == null)) {
          if (!($this.d2e_1[i] === null) || !($this.d2e_1[i] === $this)) {
            $this.d2e_1[i] = $this;
          }
        }
        return $this;
      }
      a2a() {
        return this.b2e_1;
      }
      static j2e(output, json, mode, modeReuseCache) {
        return this.t2f(Composer(output, json), json, mode, modeReuseCache);
      }
      mz() {
        return this.e2e_1;
      }
      h15(descriptor, index) {
        return this.f2e_1.f29_1;
      }
      nz(serializer, value) {
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
          if (this.a2a().s27_1.n29_1) {
            serializer.oz(this, value);
            break $l$block;
          }
          var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
          var tmp;
          if (isPolymorphicSerializer) {
            tmp = !this.a2a().s27_1.v29_1.equals(ClassDiscriminatorMode_NONE_getInstance());
          } else {
            var tmp_0;
            switch (this.a2a().s27_1.v29_1.b4_1) {
              case 0:
              case 2:
                tmp_0 = false;
                break;
              case 1:
                // Inline function 'kotlin.let' call

                var it = serializer.az().s11();
                tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            tmp = tmp_0;
          }
          var needDiscriminator = tmp;
          var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.az(), this.a2a()) : null;
          var tmp_1;
          if (isPolymorphicSerializer) {
            var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (value == null) {
                var message = 'Value for serializer ' + toString_0(serializer.az()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                throw IllegalArgumentException().a1(toString_0(message));
              } else {
                break $l$block_0;
              }
            }
            var actual = findPolymorphicSerializer(casted, this, value);
            if (!(baseClassDiscriminator == null)) {
              access$validateIfSealed$tPolymorphicKt(serializer, actual, baseClassDiscriminator);
              checkKind(actual.az().s11());
            }
            tmp_1 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
          } else {
            tmp_1 = serializer;
          }
          var actualSerializer = tmp_1;
          if (!(baseClassDiscriminator == null)) {
            var serialName = actualSerializer.az().h10();
            this.h2e_1 = baseClassDiscriminator;
            this.i2e_1 = serialName;
          }
          actualSerializer.oz(this, value);
        }
      }
      l13(descriptor) {
        var newMode = switchMode(this.b2e_1, descriptor);
        if (!(newMode.m2f_1 === _Char___init__impl__6a9atx(0))) {
          this.a2e_1.u2b(newMode.m2f_1);
          this.a2e_1.p2b();
        }
        var discriminator = this.h2e_1;
        if (!(discriminator == null)) {
          var tmp0_elvis_lhs = this.i2e_1;
          encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.h10() : tmp0_elvis_lhs);
          this.h2e_1 = null;
          this.i2e_1 = null;
        }
        if (this.c2e_1.equals(newMode)) {
          return this;
        }
        var tmp1_safe_receiver = this.d2e_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.b4_1];
        return tmp2_elvis_lhs == null ? StreamingJsonEncoder().t2f(this.a2e_1, this.b2e_1, newMode, this.d2e_1) : tmp2_elvis_lhs;
      }
      m13(descriptor) {
        if (!(this.c2e_1.n2f_1 === _Char___init__impl__6a9atx(0))) {
          this.a2e_1.q2b();
          this.a2e_1.s2b();
          this.a2e_1.u2b(this.c2e_1.n2f_1);
        }
      }
      e14(descriptor, index) {
        switch (this.c2e_1.b4_1) {
          case 1:
            if (!this.a2e_1.o2b_1) {
              this.a2e_1.u2b(_Char___init__impl__6a9atx(44));
            }

            this.a2e_1.r2b();
            break;
          case 2:
            if (!this.a2e_1.o2b_1) {
              var tmp = this;
              var tmp_0;
              if ((index % 2 | 0) === 0) {
                this.a2e_1.u2b(_Char___init__impl__6a9atx(44));
                this.a2e_1.r2b();
                tmp_0 = true;
              } else {
                this.a2e_1.u2b(_Char___init__impl__6a9atx(58));
                this.a2e_1.t2b();
                tmp_0 = false;
              }
              tmp.g2e_1 = tmp_0;
            } else {
              this.g2e_1 = true;
              this.a2e_1.r2b();
            }

            break;
          case 3:
            if (index === 0)
              this.g2e_1 = true;
            if (index === 1) {
              this.a2e_1.u2b(_Char___init__impl__6a9atx(44));
              this.a2e_1.t2b();
              this.g2e_1 = false;
            }

            break;
          default:
            if (!this.a2e_1.o2b_1) {
              this.a2e_1.u2b(_Char___init__impl__6a9atx(44));
            }

            this.a2e_1.r2b();
            this.p14(getJsonElementName(descriptor, this.b2e_1, index));
            this.a2e_1.u2b(_Char___init__impl__6a9atx(58));
            this.a2e_1.t2b();
            break;
        }
        return true;
      }
      d15(descriptor, index, serializer, value) {
        if (!(value == null) || this.f2e_1.k29_1) {
          super.d15(descriptor, index, serializer, value);
        }
      }
      r14(descriptor) {
        var tmp;
        if (get_isUnsignedNumber(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_0;
          var tmp_1 = this.a2e_1;
          if (tmp_1 instanceof ComposerForUnsignedNumbers()) {
            tmp_0 = this.a2e_1;
          } else {
            var tmp0 = this.a2e_1.n2b_1;
            var p1 = this.g2e_1;
            tmp_0 = new (ComposerForUnsignedNumbers())(tmp0, p1);
          }
          var tmp$ret$1 = tmp_0;
          tmp = StreamingJsonEncoder().t2f(tmp$ret$1, this.b2e_1, this.c2e_1, null);
        } else if (get_isUnquotedLiteral(descriptor)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
          var tmp_2;
          var tmp_3 = this.a2e_1;
          if (tmp_3 instanceof ComposerForUnquotedLiterals()) {
            tmp_2 = this.a2e_1;
          } else {
            var tmp0_0 = this.a2e_1.n2b_1;
            var p1_0 = this.g2e_1;
            tmp_2 = new (ComposerForUnquotedLiterals())(tmp0_0, p1_0);
          }
          var tmp$ret$3 = tmp_2;
          tmp = StreamingJsonEncoder().t2f(tmp$ret$3, this.b2e_1, this.c2e_1, null);
        } else if (!(this.h2e_1 == null)) {
          // Inline function 'kotlin.apply' call
          this.i2e_1 = descriptor.h10();
          tmp = this;
        } else {
          tmp = super.r14(descriptor);
        }
        return tmp;
      }
      g14() {
        this.a2e_1.w2b('null');
      }
      h14(value) {
        if (this.g2e_1) {
          this.p14(value.toString());
        } else {
          this.a2e_1.f2c(value);
        }
      }
      i14(value) {
        if (this.g2e_1) {
          this.p14(value.toString());
        } else {
          this.a2e_1.a2c(value);
        }
      }
      j14(value) {
        if (this.g2e_1) {
          this.p14(value.toString());
        } else {
          this.a2e_1.c2c(value);
        }
      }
      k14(value) {
        if (this.g2e_1) {
          this.p14(value.toString());
        } else {
          this.a2e_1.d2c(value);
        }
      }
      l14(value) {
        if (this.g2e_1) {
          this.p14(value.toString());
        } else {
          this.a2e_1.e2c(value);
        }
      }
      m14(value) {
        if (this.g2e_1) {
          this.p14(value.toString());
        } else {
          this.a2e_1.y2b(value);
        }
        if (!this.f2e_1.p29_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value, toString_0(this.a2e_1.n2b_1));
        }
      }
      n14(value) {
        if (this.g2e_1) {
          this.p14(value.toString());
        } else {
          this.a2e_1.z2b(value);
        }
        if (!this.f2e_1.p29_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value, toString_0(this.a2e_1.n2b_1));
        }
      }
      o14(value) {
        this.p14(toString(value));
      }
      p14(value) {
        return this.a2e_1.g2c(value);
      }
      q14(enumDescriptor, index) {
        this.p14(enumDescriptor.v11(index));
      }
    }
    initMetadataForClass($, 'StreamingJsonEncoder', VOID, VOID, [JsonEncoder(), AbstractEncoder()]);
    StreamingJsonEncoderClass = $;
  }
  return StreamingJsonEncoderClass;
}
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.t11() && get_unsignedNumberDescriptors().t1(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.t11() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer(Companion_getInstance()).az(), serializer_0(Companion_getInstance_0()).az(), serializer_1(Companion_getInstance_1()).az(), serializer_2(Companion_getInstance_2()).az()]);
  }
}
//region block: exports
export {
  StreamingJsonEncoder as StreamingJsonEncoder1wswwd0g47gwe,
  get_isUnsignedNumber as get_isUnsignedNumber3dxwaa3af8ncr,
};
//endregion

//# sourceMappingURL=StreamingJsonEncoder.mjs.map
